import { useState, type SyntheticEvent } from 'react';
import { Button } from '@simplywallst/ui-core';
import CheckSolid from '@simplywallst/ui-core/icons/CheckSolid';

import { useQueryClient } from '@tanstack/react-query';
import { useNarrativeSelectValuationOption } from './hooks/useNarrativeSelectValuationOption';
import { useNarrativeValuationOptions } from '@/components/NarrativeFairValue/components/NarrativeFairValueModal/hooks/useNarrativeValuationOptions';

type Props = {
  narrativeId: string;
  companyId: string;
  isPrimary: boolean;
};

export const NarrativeSetFairValue = ({
  narrativeId,
  companyId,
  isPrimary,
}: Props) => {
  const [isSettingFairValue, setIsSettingFairValue] = useState(false);
  const { mutateAsync: setFairValue } = useNarrativeSelectValuationOption();
  const queryClient = useQueryClient();

  const handleOnClick = async (event: SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (isPrimary) return;

    setIsSettingFairValue(true);
    await setFairValue({
      input: {
        companyId,
        narrativeId,
        type: 'USER_DEFINED',
      },
    });

    await queryClient.refetchQueries(
      useNarrativeValuationOptions.getOptions({
        companyId: companyId.toLowerCase(),
      })
    );
    setIsSettingFairValue(false);
  };

  return (
    <Button
      isLoading={isSettingFairValue}
      disabled={isSettingFairValue}
      styleType={isPrimary ? 'loudLarge' : 'gentleLarge'}
      onClick={handleOnClick}
    >
      {isPrimary ? (
        <>
          <CheckSolid />
          &nbsp;Fair Value
        </>
      ) : (
        'Set as Fair Value'
      )}
    </Button>
  );
};
